import { useMemo } from 'react';
import { FieldErrors, FieldValues, useFormContext } from 'react-hook-form';
import { useTranslation } from 'next-i18next';

export type ErrorType = FieldErrors<FieldValues>;
export const useErrorMessage = ({
  id,
  fieldIndex = 0,
  rootKey,
}: {
  id?: string;
  fieldIndex?: number;
  rootKey: string;
}) => {
  const defaultErrorMessage = useDefaultErrorMessage();
  const {
    formState: { errors },
  } = useFormContext();
  const errorsCp = errors;

  let errorMessageString: string;
  if (isObjectEmpty(errorsCp)) return errorMessageString;
  const errorsObject = errorsCp['root'] ? errorsCp['root'][rootKey] : errorsCp[rootKey];
  const errorMessage = id && fieldIndex > -1 ? (errorsObject?.[fieldIndex]?.[id] as ErrorType) : null;
  if (errorMessage) errorMessageString = (errorMessage?.['message'] || defaultErrorMessage) as string;
  return errorMessageString?.toString();
};
export const useDefaultErrorMessage = () => {
  const { t } = useTranslation();
  return useMemo(() => t('onboarding-page:this_field_is_required'), [t]);
};

const isObjectEmpty = (objectName: FieldValues) => JSON.stringify(objectName) === '{}';
